import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  className,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-10 py-5 text-[10px] font-extralight tracking-[0.3em] transition-all duration-500 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed uppercase relative overflow-hidden group';
  const variants = {
    primary: 'bg-[#1A1A1A] text-white hover:bg-[#D4AF37] border border-[#1A1A1A] hover:border-[#D4AF37]',
    outline: 'bg-transparent text-[#1A1A1A] border border-[#1A1A1A]/30 hover:border-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-white'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className || ''}`} {...props} data-id="element-254">
      <span className="relative z-10" data-id="element-255">{children}</span>
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" data-id="element-256"></div>
    </button>;
}